var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowAddBtn && _vm.judgePermission('vehicle_accident_list_create'))?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.JumpAdd}},[_vm._v("新建事故")]):_vm._e(),_vm._v(" "),_c('CarAccidentList',{attrs:{"loading":_vm.oLoading,"params":_vm.params,"isCarDetail":_vm.isCarDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }